import classNames from 'classnames';
import React from 'react';
import caretIcon from '../icons/caret.svg';
import styles from './Caret.module.scss';
import type { SVGIconSize } from './SVGIcon';
import SVGIcon from './SVGIcon';

export type CaretDirection = 'up' | 'down' | 'left' | 'right';

interface CaretProps {
  direction?: CaretDirection;
  inline?: boolean;
  block?: boolean;
  size?: SVGIconSize;
}

const Caret = ({
  direction = 'down',
  inline = false,
  block = false,
  size = 8,
}: CaretProps) => {
  return (
    <SVGIcon
      className={classNames(styles.caret, styles[direction], {
        [styles.block]: block,
      })}
      inline={inline}
      size={size}
    >
      {caretIcon}
    </SVGIcon>
  );
};

export default Caret;
